const approveStatusList = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
];

export { approveStatusList };